// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2josM","list":"BalanceDue_list__3OiJ4","listRow":"BalanceDue_listRow__3RvMp","total":"BalanceDue_total__2eLrn"};